<template>
  <div class="grid grid-cols-4 col-gap-8">
    <VueCtkDateTimePicker v-model="date_range"
                          format="YYYY-MM-DD"
                          formatted="L"
                          :range="true"
                          :auto-close="true"
                          :custom-shortcuts="datepickerShortcuts"
                          :locale="$store.state.i18n.lang"
                          :label="$t('dateLabel')"
                          :no-label="false"
                          :no-clear-button="true"
                          :no-button="true"
                          color="#486680"/>
    <BaseInput v-model.trim="ticker"
               :label="$t('tickerLabel')">
      <template v-slot:icon>
        <IconSearch class="text-icon"/>
      </template>
    </BaseInput>
    <BaseSelect v-model="instrument_type"
                :options="objectsList"
                track-by="value"
                :select-label="$t('objectsLabel')"
                :label="`title_${$i18n.locale}`"
                :searchable="false"
                :show-labels="false"
                :allow-empty="false"/>
    <DealsFiltersEvents/>
  </div>
</template>

<script>
import {mapGetters, mapMutations, mapState} from "vuex";
import BaseInput from "@/components/UI/BaseInput/BaseInput";
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";
import IconSearch from "@/components/icons/IconSearch";
import DealsFiltersEvents from "@/components/cabinet/Investments/InvestmentDeals/DealsFilters/DealsFiltersEvents";

export default {
  name: "DealsFilters",
  components: {DealsFiltersEvents, IconSearch, BaseSelect, BaseInput},
  data() {
    return {
      objectsList: [
        {title_en: 'All', title_ru: 'Все', value: 0},
        {title_en: 'Stocks', title_ru: 'Акции', value: 1},
        {title_en: 'Bonds', title_ru: 'Облигации', value: 2},
        {title_en: 'Funds', title_ru: 'Фонды', value: 3},
        {title_en: 'Forex', title_ru: 'Валюта', value: 4},
      ]
    }
  },
  computed: {
    ...mapState('investments/deals', ['filters']),
    ...mapGetters('space', ['spaceTimeZone', 'spaceFirstTransactions']),
    datepickerShortcuts: {
      get() {
        return [{
          key: 'thisMonth',
          label: 'Месяц',
          value: () => ({start: this.$moment().startOf('month'), end: this.$moment()})
        },
          {
            key: 'thisQuarter',
            label: 'Квартал',
            value: () => ({start: this.$moment().startOf('quarter'), end: this.$moment()})
          },
          {
            key: 'thisYear',
            label: 'Этот год',
            value: () => ({start: this.$moment().startOf('year'), end: this.$moment()})
          },
          {
            key: 'year',
            label: 'Год',
            value: () => ({start: this.$moment().subtract(12, 'month'), end: this.$moment()})
          },
          {key: 'all', label: 'С начала', value: this.spaceFirstTransactions},
        ]
      }
    },
    date_range: {
      get() {
        return this.filters.date;
      },
      set(value) {
        this.setFilter({name: 'date', value})
      }
    },
    ticker: {
      get() {
        return this.filters.ticker;
      },
      set(value) {
        this.setFilter({name: 'ticker', value})
      }
    },
    instrument_type: {
      get() {
        return this.filters.instrument_type;
      },
      set(value) {
        this.setFilter({name: 'instrument_type', value})
      }
    }
  },
  methods: {
    ...mapMutations('investments/deals', ['setFilter']),
    setInitialRange() {
      let now = this.$moment().format('YYYY-MM-DD'),
          month_start = this.$moment().startOf('month').format('YYYY-MM-DD');

      this.date_range = {
        start: month_start,
        end: now
      }
    },
  },
  mounted() {
    this.setInitialRange();
  },
  i18n: {
    messages: {
      en: {
        dateLabel: 'Operation\'s date',
        objectsLabel: 'Objects',
        tickerLabel: 'Ticker'
      },
      ru: {
        dateLabel: 'Дата операции',
        objectsLabel: 'Объекты',
        tickerLabel: 'Тикер'
      }
    }
  }
}
</script>